import { ReasonRefusal } from './types';

export const setReasonsRefusal = (payload: any) => {
  return {
    type: ReasonRefusal.GET_REASONS_REFUSAL,
    payload,
  };
};

export const setReasonRefusal = (payload: any) => {
  return {
    type: ReasonRefusal.SET_REASON_REFUSAL,
    payload,
  };
};
